import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getReaderParameters } from "actions/user";
import Message from "containers/SinglePages/Partials/Message";
import { getDescription } from "helpers/content";
import Moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";
import { Spinner, Expandable } from "UI";
import PostContent from "components/Presentation/PostContent";
import AssessmentsConsumer from "components/BlockAssessments/Consumer";
import { getGuardianStudentAssignment, getGuardianStudentAssignmentAssessments, getTeamsAssignment, getTeamsAssignmentOutcomes, getTeamsAssignmentResources, getTeamsAssignmentResource } from "actions/assignments";
import { getBlocksByReference } from "actions/blocks";
import { setPageTitle } from "actions/header";
import { getCourse } from "actions/sections";
import { Immersive_Reader } from "UI/Icons";
import { Block, translate, getActiveLanguage } from "@haldor/ui";
import Outcomes from './Partials/Outcomes';
import './MicrosoftAssignment.scss';
var ImmersiveReader = require("@microsoft/immersive-reader-sdk");
var MicrosoftAssignment = /*#__PURE__*/function (_Component) {
  function MicrosoftAssignment(props) {
    var _this;
    _classCallCheck(this, MicrosoftAssignment);
    _this = _callSuper(this, MicrosoftAssignment, [props]);
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      if (_this.props.task != null) {
        _this.props.setPageTitle(_this.props.task.title);
      }
    });
    _defineProperty(_this, "componentDidMount", function () {
      var _this$props = _this.props,
        activeStudent = _this$props.activeStudent,
        task = _this$props.task;
      var services = _this.getServices();
      var promises = [];
      var assignmentId = _this.props.task.id;

      // We need to get haldorAssignmentObject if it is possible to render assoicatedMatrices and get sectionId
      if (assignmentId != null && assignmentId > -1 && assignmentId == parseInt(assignmentId, 10)) {
        var assignmentPromise = _this.props.getGuardianStudentAssignment(activeStudent.id, assignmentId);
        promises.push(assignmentPromise);
      } else {
        var _assignmentPromise = _this.props.getTeamsAssignment(activeStudent.id, task.sectionId, task.externalId);
        promises.push(_assignmentPromise);
      }
      if (services.haldorAssessments && assignmentId != null && assignmentId > -1 && assignmentId == parseInt(assignmentId, 10)) {
        var assessments = _this.props.getGuardianStudentAssignmentAssessments(_this.props.task.id);
        promises.push(assessments);
      }
      var assignmentResources = _this.props.getTeamsAssignmentResources(activeStudent.id, task.sectionId, task.externalId);
      promises.push(assignmentResources);
      if (services.microsoftAssessments) {
        var outcomes = _this.props.getTeamsAssignmentOutcomes(activeStudent.id, task.sectionId, task.externalId);
        promises.push(outcomes);
      }
      Promise.all(promises).then(function () {
        _this.props.getBlocksByReference(_this.props.task.id, "ASSIGNMENT").then(function () {
          _this.setState({
            loadingBlocks: false
          });
        });

        // We should only run this API if we can get sectionId from HaldorAssigmentObject
        if (services.haldorAssessments && _this.props.haldorAssignmentObject != null) {
          if (_this.props.haldorAssignmentObject.associatedMatrices != null) {
            _this.props.haldorAssignmentObject.associatedMatrices.forEach(function (matrix) {
              if (_this.getCourse(matrix.courseId) == null) {
                _this.props.getCourse(matrix.courseId);
              }
            });
          }
        }
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "getCourse", function (courseId) {
      return _this.props.courses.find(function (course) {
        return course.id == courseId;
      });
    });
    _defineProperty(_this, "getServices", function () {
      return {
        haldorAssessments: _this.props.activeStudent != null && _this.props.activeStudent.services.assessments,
        microsoftAssessments: _this.props.activeStudent != null && _this.props.activeStudent.services.msAssignmentOutcomes,
        conversations: _this.props.activeStudent != null && _this.props.activeStudent.services.conversations
      };
    });
    _defineProperty(_this, "runImmersiveReader", function () {
      var task = _this.props.task;
      var description = task.description;
      if ((description == null || _this.props.task.description.length <= 0) && _this.props.haldorAssignmentObject != null && _this.props.haldorAssignmentObject.description != null) {
        description = _this.props.haldorAssignmentObject.description;
      }
      var data = {
        title: task.title,
        chunks: [{
          content: "<h1>" + task.title + "</h1>",
          mimeType: "text/html"
        }, {
          content: getDescription(description),
          mimeType: "text/html"
        }]
      };
      _this.props.getReaderParameters().then(function () {
        var reader = _this.props.reader;
        ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
          uiLang: getActiveLanguage()
        })["catch"](function (error) {
          console.error("error", error);
          //trackImmersiveReaderError(error, currentUser.id);
        });
      });
    });
    _defineProperty(_this, "renderOutcomes", function () {
      var _this$props2 = _this.props,
        outcomes = _this$props2.outcomes,
        translate = _this$props2.translate;
      if (outcomes == null) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        style: {
          marginBottom: '1.25rem'
        }
      }, translate('Assessment')), /*#__PURE__*/React.createElement(Block, null, outcomes.points != null && outcomes.points != '' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Points')), outcomes.points, " / ", _this.props.task.maxPoints)
      // :
      // 	<span style={{ color: 'var(--color--meta)' }}>
      // 		{translate('No points have been awarded to this assignment')}
      // 	</span>
      : null, outcomes.feedback != null && outcomes.feedback != '' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: '1rem'
        }
      }, translate('Feedback')), /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(outcomes.feedback)
        }
      })) : null), outcomes.rubricOutcomes != null && outcomes.rubricOutcomes.length > 0 ? /*#__PURE__*/React.createElement(Outcomes, {
        outcomes: outcomes
      }) : null);
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  _inherits(MicrosoftAssignment, _Component);
  return _createClass(MicrosoftAssignment, [{
    key: "renderResources",
    value: function renderResources() {
      var _this2 = this;
      var _this$props3 = this.props,
        activeStudent = _this$props3.activeStudent,
        task = _this$props3.task,
        assignmentResources = _this$props3.assignmentResources,
        translate = _this$props3.translate;
      var handleOpenResource = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resource) {
          var getTeamsAssignmentResource;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                getTeamsAssignmentResource = _this2.props.getTeamsAssignmentResource;
                _context.next = 3;
                return getTeamsAssignmentResource(activeStudent.id, task.sectionId, task.externalId, resource.id, resource.displayName);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function handleOpenResource(_x) {
          return _ref.apply(this, arguments);
        };
      }();
      return /*#__PURE__*/React.createElement("div", null, assignmentResources === null || assignmentResources === void 0 ? void 0 : assignmentResources.map(function (resource) {
        return /*#__PURE__*/React.createElement("div", {
          className: "block-container",
          key: resource.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "block-content"
        }, resource.url == null ? /*#__PURE__*/React.createElement("button", {
          type: "button",
          onClick: function onClick() {
            return handleOpenResource(resource);
          },
          className: "link-button"
        }, resource.displayName) : /*#__PURE__*/React.createElement("button", {
          type: "button",
          onClick: function onClick() {
            return window.open(resource.url, '_system' in window ? '_system' : '_blank');
          },
          className: "link-button"
        }, resource.displayName), resource.template ? " (".concat(translate('Template'), ")") : null));
      }));
    }
  }, {
    key: "renderAssignment",
    value: function renderAssignment() {
      var _this3 = this;
      var _this$props4 = this.props,
        translate = _this$props4.translate,
        outcomes = _this$props4.outcomes;
      var services = this.getServices();
      var assessmentBlocks = [];
      var assessment = null;
      if (this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == "Haldor.Blocks.AssessmentBlock";
        });
      }
      if (this.props.assessments != null) {
        assessment = this.props.assessments.find(function (assessment) {
          return assessment.studentId == _this3.props.activeStudent.id;
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Assignment information')), /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), " ", translate('Immersive Reader'))), this.props.task.description != null && this.props.task.description.length > 0 ? /*#__PURE__*/React.createElement(PostContent, null, this.props.task.description) : this.props.haldorAssignmentObject != null && this.props.haldorAssignmentObject.description != null ? /*#__PURE__*/React.createElement(PostContent, null, this.props.haldorAssignmentObject.description) : null, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate('Due')), /*#__PURE__*/React.createElement("div", null, Moment.utc(this.props.task.dueDate).local().format("D MMM H:mm")), /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate('Group')), this.props.task.sectionTitle, services.conversations != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
        student: this.props.activeStudent,
        assignment: this.props.task
      })) : null, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: '1rem'
        }
      }, translate('Status')), translate(this.props.task.status).capitalize(), this.props.assignmentResources != null && this.props.assignmentResources.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate('Files')), this.renderResources()))), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        className: "single-section-divider"
      }), services.haldorAssessments ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(AssessmentsConsumer, {
        fields: assessmentBlocks,
        assessment: assessment
      })) : null, services.microsoftAssessments && outcomes != null && (outcomes.feedback != null && outcomes.feedback != '' || outcomes.points != null && outcomes.points != '' || outcomes.rubricOutcomes != null && outcomes.rubricOutcomes.length > 0) ? this.renderOutcomes() : null);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderAssignment());
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    status: state.base.status,
    courses: state.groups.courses,
    haldorAssignmentObject: state.assignments.assignment,
    assessments: state.assignments.assessments,
    outcomes: state.assignments.outcomes,
    assignmentResources: state.assignments.assignmentResources,
    reader: state.User.reader,
    translate: translate(state.Languages.translations),
    blocks: state.Blocks.reference
  };
};
export default connect(mapStateToProps, {
  getGuardianStudentAssignment: getGuardianStudentAssignment,
  getCourse: getCourse,
  getGuardianStudentAssignmentAssessments: getGuardianStudentAssignmentAssessments,
  getReaderParameters: getReaderParameters,
  setPageTitle: setPageTitle,
  getTeamsAssignment: getTeamsAssignment,
  getTeamsAssignmentOutcomes: getTeamsAssignmentOutcomes,
  getBlocksByReference: getBlocksByReference,
  getTeamsAssignmentResources: getTeamsAssignmentResources,
  getTeamsAssignmentResource: getTeamsAssignmentResource
})(MicrosoftAssignment);